import { cn } from "~/lib/utils";
import { FALLBACK_IMAGE_URL } from "~/utils/constant";

const CardShadow = ({ bgImage = FALLBACK_IMAGE_URL, isChildren = false }: { bgImage?: string; isChildren?: boolean }) => {
  return (
    <>
      <div
        className={cn(
          "absolute -top-2.5 xs:-top-2 left-1  lg:w-[93%] 2xl:w-[95%] h-[10%] bg-black/30 rounded-xl translate-y-[4px] translate-x-[4px] z-0 opacity-50",
          isChildren ? "xs:w-[88%]" : "xs:w-[90%]",
        )}
        style={{ backgroundImage: `url(${bgImage})` }}
      ></div>
      {/* <div className="absolute -top-3.5 xs:-top-2.5 left-4 xs:w-[80%] lg:w-[85%] 2xl:w-[90%] h-[10%] bg-black/20 rounded-xl translate-y-[2px] translate-x-[2px] z-0"></div> */}
    </>
  );
};

export default CardShadow;
